import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const SprzWynikPage = lazy(() => import("@/features/reports/sprz-wynik-page"));

const searchSchema = z.object({
	listId: z.coerce.number().int().positive().optional().catch(undefined),
	mode: z.enum(["full", "toYesterday"]).optional().catch(undefined),
	apteka: z.enum(["z-internetowa"]).optional().catch(undefined),
});

export type SprzWynikSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/sprz-wynik")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sprz-wynik",
			location.pathname,
		);
	},
	component: SprzWynikPage,
	validateSearch: (search: Record<string, unknown>): SprzWynikSearch => searchSchema.parse(search),
});
